import { defaultStoreUtils } from '@databases/redux';
import { getMainFieldId } from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import DatabaseValueView from '../../database-value/DatabaseValueView';

const Container = styled.span<{ isMainField: boolean }>`
  font-size: ${(props) => (props.isMainField ? '16px' : 'inherit')};
  line-height: ${(props) => (props.isMainField ? '20px' : 'inherit')};
  font-weight: ${(props) => (props.isMainField ? '500' : 'inherit')};
`;

interface EntryCardProps {
  contentId: string;
  entryId: string;
  fieldId: string;
  isReadonly?: boolean;
}

const EntryCardValue: FunctionComponent<EntryCardProps> = ({
  contentId,
  entryId,
  fieldId,
  isReadonly,
}) => {
  const isMainField = defaultStoreUtils.useShallowEqualSelector((state) => {
    const databaseDraft = selectDatabaseByContentIdRequired(state, {
      contentId,
    });
    return fieldId === getMainFieldId(databaseDraft);
  });

  return (
    <Container isMainField={isMainField}>
      <DatabaseValueView
        contentId={contentId}
        entryId={entryId}
        fieldId={fieldId}
        isReadonly={isReadonly}
        showFieldNamePlaceholder
      />
    </Container>
  );
};

export default EntryCardValue;
